<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'
import type {
    PoolStationConnectorForDisplay,
    PoolStationConnectorRealtimeStatusCount,
    PoolStationConnectorType
} from '~~/interfaces/station'
import AppPoolConnector from './PoolConnector.vue'
import { PoolRealtimeState } from '#cmui/types/pool'

const poolStore = usePoolStore()

const getConnectorsCount = (
    poolConnector: PoolStationConnectorForDisplay
): number =>
    poolConnector.realtimeStatusCount?.reduce(
        (total, current) => total + current.count,
        0
    ) || 0

const getAvailableConnectorsCount = (
    poolConnector: PoolStationConnectorForDisplay
): number =>
    poolConnector.realtimeStatusCount?.filter(
        (realtimeStatusCount: PoolStationConnectorRealtimeStatusCount) =>
            realtimeStatusCount?.realtimeStatus === PoolRealtimeState.AVAILABLE
    )[0]?.count || 0

const getPower = (poolConnector: PoolStationConnectorForDisplay): number =>
    poolConnector.power || 0

const getConnectorType = (
    poolConnector: PoolStationConnectorForDisplay
): PoolStationConnectorType | object => poolConnector.connectorType || {}

onMounted(() => {
    poolStore.fetchPoolStationsFromCommunity()
})
</script>

<template>
    <div>
        <Loader
            v-if="poolStore.communityPoolStationsLoader"
            class="min-h-14 w-full"
        />
        <div v-else class="w-full flex gap-2.5 flex-wrap min-h-14">
            <div
                v-for="poolConnector of poolStore.poolConnectors"
                :key="`${poolConnector.id}`"
            >
                <AppPoolConnector
                    :total-connectors-count="getConnectorsCount(poolConnector)"
                    :available-connectors-count="
                        getAvailableConnectorsCount(poolConnector)
                    "
                    :power-connector="getPower(poolConnector)"
                    :connector-type="getConnectorType(poolConnector)"
                />
            </div>
        </div>
    </div>
</template>
